import { combineReducers } from "redux";
import { constReducer } from "./reducers";
import { reducer as actionPlans } from "../modules/Dashboard/ActionPlans";
import { reducer as currentUser } from "../modules/CurrentUser";
import { reducer as cycleForm } from "../modules/Dashboard/Cycles/CreateCycle";
import { reducer as cycleParticipants } from "../modules/Dashboard/Cycles/CycleParticipants";
import { reducer as cyclesList } from "../modules/Dashboard/Cycles/CyclesList";
import { reducer as feedback } from "../modules/Dashboard/MyFeedbacks";
import { reducer as managerDashboard } from "../modules/Dashboard/ManagerDashboard";
import { reducer as myEmployees } from "../modules/Dashboard/MyEmployees";
import { reducer as myPeerQuestionnaire } from "../modules/MyPeerQuestionnaire";
import { reducer as myPeers } from "../modules/Dashboard/MyPeers";
import { reducer as myQuestionnaire } from "../modules/MyQuestionnaire";
import { reducer as talkSheet } from "../modules/TalkSheet";
export default combineReducers({
  actionPlans,
  constReducer,
  currentUser,
  cycleForm,
  cycleParticipants,
  cyclesList,
  feedback,
  managerDashboard,
  myEmployees,
  myPeerQuestionnaire,
  myPeers,
  myQuestionnaire,
  talkSheet
});
